import React, {Component} from 'react';
import {getReferenceByID} from "../../../../services/referencesService"
import {Redirect, withRouter} from 'react-router-dom';
import LoadingComponent from "../../common/loadingComponent";
import ReferenceForm from "./ReferenceForm";

class LoadReferenceForm extends Component {

    _isMounted = false;

    state = {
        RedirectToLoginPage:false,
        isLoading : false,
        userToken : this.props.user,
        reference : {},
        locale : this.props.locale
    };


    componentDidMount() {
        this._isMounted = true;
        if (this.props.id !== undefined) {
            this.onLoadReference();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadReference = async () =>{
        try {
            this.setState({isLoading:true});
            const {data: reference} = await getReferenceByID(this.props.id);
            if (this._isMounted){
                this.setState({
                    reference,
                    isLoading: false
                });
            }

        }  catch(err)  {
            if (this._isMounted){
                this.setState({isLoading: false, RedirectToLoginPage:true});
            }
        }
    }


    renderPage = () => {
        return (
          <>
              <ReferenceForm
                  isAdminForm = {(this.props.id)?true:false}
                  locale = {this.props.locale}
                  reference = {this.state.reference}
              />
          </>
        );
    }

    render() {

        if (this.state.RedirectToLoginPage) {
            const loginPage = `/${this.state.locale}/login`
            return <Redirect to={loginPage}  />
        }

        return (
            <>
                {this.state.isLoading ? <LoadingComponent/> : this.renderPage()}
            </>
        );
    }
}

export default withRouter(LoadReferenceForm);
